/*
 * Copyright (c) 2021 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Friday, November 12th 2021, 9:45:57 am
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import {
  APIFormInputErrorWrapper,
  CustomInputValidationErrorWrapper,
  HelperTextInputWrapper,
} from "ui-widgets/forms/FormInputWrappers";
import { FormControl } from "@mui/material";
import { APIRelatedObjectInputProps } from "ui-widgets/forms/types";
import { OSFormInputProps } from "ui-widgets/forms/types";
import { StyledOSDialogProps, OSActionButtonProps } from "ui-widgets";

export type GenericAPIRelatedFormPopupInputProps<PrimaryObject, RelatedObject> = OSFormInputProps<PrimaryObject> &
  APIRelatedObjectInputProps<RelatedObject> &
  Pick<StyledOSDialogProps, "popUpTitle" | "popUpDescription" | "children"> &
  Partial<Pick<OSActionButtonProps, "variant">>;

export type ConcreteAPIRelatedFormPopupInputProps<PrimaryObject, RelatedObject> = Omit<
  GenericAPIRelatedFormPopupInputProps<PrimaryObject, RelatedObject>,
  "PopUpFormComponent" | "itemIdProperty" | "getOptionLabel"
>;

export const APIFormRelatedPopupInputWrapper = <PrimaryObject, RelatedObject>(
  props: GenericAPIRelatedFormPopupInputProps<PrimaryObject, RelatedObject>
) => {
  return (
    <APIFormInputErrorWrapper schema_field_key={props.schema_field_key} label={props.label}>
      <CustomInputValidationErrorWrapper schema_field_key={props.schema_field_key} label={props.label}>
        <HelperTextInputWrapper helperText={props.helperText}>
          <FormControl>{props.children} </FormControl>
        </HelperTextInputWrapper>
      </CustomInputValidationErrorWrapper>
    </APIFormInputErrorWrapper>
  );
};
